import React from 'react';
import './Sidebar.css';
import { Link } from 'react-router-dom';

function Sidebar({ crops }) {
  // Sort the crops array alphabetically based on the crop names
  const sortedCrops = crops.sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div>
      <div className="sidebar" id="sidebar">
        Crops List
        <ul>
          {/* Render the sorted list of crops */}
          {sortedCrops.map((crop) => (
            <li key={crop.name}>
              <Link to={`/table/${crop.name}`}>{crop.name}</Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Sidebar;

